import { useMutation } from '@tanstack/react-query'
import { TRPCClientError } from '@trpc/client'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useConfirmModal } from '@maxus/website/components'
import { queryClient, trpc, trpcClient } from '@maxus/website/lib'

export const useLogout = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { confirm } = useConfirmModal()

  // 清登录态缓存 + 跳登录页；onSuccess 与「会话已失效返回 401」分支共用。
  // 必须 removeQueries（触发重探测 → 401 → guest），不能 setQueryData(null)——否则 status 仍判 authed，
  // RedirectIfAuthed 会把用户弹回受保护页，等于没登出。
  const finishLogout = () => {
    queryClient.removeQueries({ queryKey: trpc.auth.me.queryKey() })
    navigate('/login')
  }

  const confirmLogout = () => {
    confirm({
      cancelLabel: t('Cancel'),
      className: 'h-[148px]',
      confirmLabel: t('Confirm'),
      description: t('Signing in again requires Feishu authorization.'),
      onConfirm: () => {
        if (logout.isPending) return
        logout.mutate()
      },
      title: t('Sign out?'),
    })
  }

  const logout = useMutation({
    mutationFn: () => trpcClient.auth.logout.mutate(),
    onSuccess: finishLogout,
    onError: err => {
      // 仅 UNAUTHORIZED（服务端会话本就已失效）视为已登出；其余（网络/5xx）停在当前页可重试。
      if (err instanceof TRPCClientError && err.data?.code === 'UNAUTHORIZED') {
        finishLogout()
      }
    },
  })

  return { confirmLogout }
}
